export default function AboutSection() {
  return (
    <section className="bg-background-200/70 py-14 md:py-20">
      <div className="max-w-[800px] mx-auto px-4 md:px-6 text-center">
        <p className="text-xs md:text-sm text-foreground-500 uppercase tracking-wider mb-4 font-label">
          Unsere Redaktion & Transparenz
        </p>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6">
          Qualität, auf die du dich verlassen kannst
        </h2>
        <div className="text-left space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
          <p>
            Unser Redaktionsteam besteht aus einem <strong>Senior Editor</strong>, einem 
            <strong> SEO Reviewer</strong>, einem <strong>Content Reviewer</strong> sowie einem 
            <strong> deutschen Muttersprachler als Lektor</strong>. Gemeinsam mit unserem 
            <strong> Technical Reviewer</strong> und <strong>Fact Checker</strong> stellen wir sicher, 
            dass jeder Artikel höchsten Qualitätsstandards entspricht.
          </p>
          <p>
            Unser <strong>Redaktioneller Prozess</strong> umfasst strenge 
            <strong> redaktionelle Richtlinien</strong>, einen mehrstufigen <strong>Review-Prozess</strong>, 
            systematische <strong>Faktenprüfung</strong> und eine transparente 
            <strong> Aktualisierungsrichtlinie</strong>. Alle Inhalte werden regelmäßig auf 
            Richtigkeit und Relevanz überprüft.
          </p>
          <p>
            Der OOPBUY Spreadsheet ist dein verlässlicher Begleiter für den Einkauf auf 
            Taobao, Weidian und Yupoo. Mit integriertem QC-System, Agent-Verwaltung 
            und Shipping-Tracking behältst du stets den Überblick über deine Bestellungen.
          </p>
        </div>
        <div className="mt-8">
          <a
            href="/was-ist-oopbuy-spreadsheet"
            className="inline-flex items-center gap-2 text-primary-600 hover:text-primary-700 font-medium text-sm md:text-base transition-colors whitespace-nowrap cursor-pointer"
          >
            Mehr zum OOPBUY Spreadsheet
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}